import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCarousel from 'vue-carousel'
import _url_ from './_url_'
import i18n from './i18n/i18n'
import ElementUI from 'element-ui'
import VueLazyload from 'vue-lazyload'
import ECharts from 'vue-echarts/components/ECharts.vue'
import qs from 'qs'
import method  from './store/modules/user'


Vue.prototype.$qs = qs;

Vue.config.productionTip = false

Vue.use(VueCarousel);
Vue.use(VueLazyload,{
	preLoad: 1.3,
  loading: require("./assets/img/images/loading.gif"),
  error: require("./assets/img/images/error.jpg"),
  attempt: 2
});

Vue.prototype.$URL = _url_;

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/pagination.css'
import './assets/css/button.css'
import './assets/css/dialog.css'
import './assets/css/tabs.css'
import './assets/css/transfer.css'
Vue.use(ElementUI);

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
import 'echarts/lib/component/dataZoom'
Vue.component('v-chart', ECharts)

let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
});
vm.$mount('#app');

router.beforeResolve((to, from, next) => {
  method.actions.refreshJurisdiction(method.state,method.mutations.setLogin2)
  let islogin = store.state.user.islogin,
  allow = to.path.indexOf("center") >= 0 || to.name == "cartOrder" || to.path.indexOf("service") >= 0;
  if(allow && !islogin){
    Vue.prototype.$alert(vm.$t("public.notLogin"), {
      confirmButtonText: vm.$t("public.goLogin"),
      callback: () => {
        next("/login");
      }
    })
    return
  }
  next();
})